import { Container } from '@mui/material';
import Layout from '@/components/layout/main-layout';

import ScrollToTop from '@/components/ui/scroll-to-top';

import EmployeesPanel from '@/components/employees';
import { useAppSelector } from '@/redux-store/store';

const EmployeeManagementPage: React.FC = () => {
  const companyId = useAppSelector((store) => store.company.company._id);

  return (
    <Layout firstTranslationKey={'employee_management'}>
      <Container
        maxWidth={'md'}
        sx={{
          pt: 2,
          marginTop: 1,
          position: 'relative'
        }}
      >
        {companyId && <EmployeesPanel companyId={companyId} />}
      </Container>
      <ScrollToTop />
    </Layout>
  );
};

export default EmployeeManagementPage;
